export interface OpeningPeriod {
  open: { day: number; hour: number; minute: number };
  close?: { day: number; hour: number; minute: number };
}

export interface OpeningHoursData {
  weekdayDescriptions?: string[];
  periods?: OpeningPeriod[];
}

export function isVenueOpen(openingHours: OpeningHoursData | null | undefined, now?: Date): boolean {
  if (!openingHours?.periods || openingHours.periods.length === 0) return true;

  const d = now || new Date();
  const currentDay = d.getDay();
  const currentMinutes = d.getHours() * 60 + d.getMinutes();

  for (const period of openingHours.periods) {
    if (!period.close) {
      return true;
    }

    const openDay = period.open.day;
    const closeDay = period.close.day;
    const openMin = period.open.hour * 60 + period.open.minute;
    const closeMin = period.close.hour * 60 + period.close.minute;

    if (openDay === closeDay) {
      if (currentDay === openDay && currentMinutes >= openMin && currentMinutes < closeMin) {
        return true;
      }
    } else {
      if (currentDay === openDay && currentMinutes >= openMin) {
        return true;
      }
      if (currentDay === closeDay && currentMinutes < closeMin) {
        return true;
      }
      const daysBetween = (closeDay - openDay + 7) % 7;
      if (daysBetween > 1) {
        for (let offset = 1; offset < daysBetween; offset++) {
          if (currentDay === (openDay + offset) % 7) return true;
        }
      }
    }
  }

  return false;
}

export function hasNoCapacityData(venue: {
  googleRating: number | null;
  googleRatingCount: number | null;
  reportCount: number;
  capacityLevel: number;
}): boolean {
  return (
    !venue.googleRating &&
    !venue.googleRatingCount &&
    venue.reportCount === 0 &&
    venue.capacityLevel === 0
  );
}
